export default __webpack_public_path__ + "static/media/094802b57bdcb9c27ab8639691222f6f.svg";